type Tab = {
  id: string;
  label: string;
};

export function Tabs({
  tabs,
  active,
  onChange,
}: {
  tabs: Tab[];
  active: string;
  onChange: (id: string) => void;
}) {
  return (
    <div className="flex h-[31px] gap-l">
      {tabs.map(tab => {
        const isActive = tab.id === active;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            className={`flex h-full items-center justify-center text-[12px] font-medium leading-[17.8px] ${
              isActive ? 'border-b-2 border-content text-content' : 'text-content-muted'
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
